import type { LessonRecurringDayForm } from '../../lesson-recurring'
import type { LessonRecurringStore } from './interfaces'

import { createLessonRecurringState } from './state'

export const actions = {
  setLoading (this: LessonRecurringStore, payload: LessonRecurringStore['loading']): void {
    this.loading = payload
  },
  setSlots (this: LessonRecurringStore, payload: LessonRecurringStore['slots']): void {
    this.slots = payload
  },
  setModal (this: LessonRecurringStore, payload: LessonRecurringStore['modal']): void {
    this.modal = payload
  },
  setToday (this: LessonRecurringStore, payload: LessonRecurringStore['today']): void {
    this.today = payload
  },
  setStartDate (this: LessonRecurringStore, payload: LessonRecurringStore['startDate']): void {
    this.startDate = payload
  },
  setDays (this: LessonRecurringStore, payload: LessonRecurringStore['days']): void {
    this.days = payload
  },
  patchDay (this: LessonRecurringStore, day: string, patch: Partial<LessonRecurringDayForm>): void {
    this.days = this.days.map(item => (item.day === day ? { ...item, ...patch } : item))
  },
  setSelectedDay (this: LessonRecurringStore, payload: LessonRecurringStore['selectedDay']): void {
    this.selectedDay = payload
  },
  setFinishType (this: LessonRecurringStore, payload: LessonRecurringStore['finishType']): void {
    this.finishType = payload
  },
  setOccurrences (this: LessonRecurringStore, payload: LessonRecurringStore['occurrences']): void {
    this.occurrences = payload
  },
  setLessons (this: LessonRecurringStore, payload: LessonRecurringStore['lessons']): void {
    this.lessons = payload
  },
  setFinishDate (this: LessonRecurringStore, payload: LessonRecurringStore['finishDate']): void {
    this.finishDate = payload
  },
  setFilters (this: LessonRecurringStore, payload: LessonRecurringStore['filters']): void {
    this.filters = payload
  },
  setTutors (this: LessonRecurringStore, payload: LessonRecurringStore['tutors']): void {
    this.tutors = payload
  },
  setTutorsLoading (this: LessonRecurringStore, payload: LessonRecurringStore['tutorsLoading']): void {
    this.tutorsLoading = payload
  },
  setTutorId (this: LessonRecurringStore, payload: LessonRecurringStore['tutorId']): void {
    this.tutorId = payload
  },
  setSubmitting (this: LessonRecurringStore, payload: LessonRecurringStore['submitting']): void {
    this.submitting = payload
  },
  reset (this: LessonRecurringStore): void {
    Object.assign(this, createLessonRecurringState())
  },
}
